<script setup>
import {
    formataCpf,
    formataMoedaReais
} from '@kodatec/brasil-utils';

defineProps({
    solicitacao: {
        type: Object,
        required: true
    }
})
</script>

<template>
    <h3 class="text-900 font-bold text-sm mb-3 col-12">Dados da Solicitação</h3>

    <LabelDados titulo="Beneficiário" :conteudo="solicitacao.dados.pessoa_fisica_nome || solicitacao.dados.pessoafisica_nome" :detalhe="'CPF: ' +
    formataCpf((solicitacao.dados.pessoa_fisica_cpf || solicitacao.dados.pessoafisica_cpf), false)" />

    <LabelDados titulo="Valor" :conteudo="formataMoedaReais(solicitacao.dados.valor)" />

    <LabelDados titulo="Justificativa" :conteudo="solicitacao.dados.justificativa" tamanho_div="col-12" />

</template>